import React from "react";
import { useSelector } from "react-redux";

const ProfilePopUp = () => {
  const userData = useSelector(
    (state) => state.cards.profile?.data?.response?.profile,
  );

  const permanentAddress =
    userData?.permanentAddress || userData?.permanent_address;

  const communicationAddress = [
    userData?.communication_address_line_1,
    userData?.communication_address_line_2,
    userData?.communication_address_line_3,
    userData?.communication_city,
    [userData?.communication_state, userData?.communication_pincode]
      .filter(Boolean)
      .join(" "),
  ]
    .filter(Boolean)
    .join(", ");

  const permanentFullAddress =
    [
      userData?.address_line_1,
      userData?.address_line_2,
      userData?.address_line_3,
      userData?.city,
      [userData?.state, userData?.pincode].filter(Boolean).join(" "),
    ]
      .filter(Boolean)
      .join(", ") || "--";

  return (
    <div className="popup-overlay">
      <div className="d-flex gap2">
        {/* LEFT SECTION */}
        <div className="w45">
          <div className="detail-row">
            <span className="label">Card Holder Name:</span>
            <span className="value">
              {userData?.first_name || userData?.firstName}{" "}
              {userData?.last_name || userData?.lastName}
            </span>
          </div>

          <div className="detail-row">
            <span className="label">Mobile Number:</span>
            <span className="value">{userData?.primary_phone || "--"}</span>
          </div>

          <div className="detail-row">
            <span className="label">Email:</span>
            <span className="value">{userData?.email || "--"}</span>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="w45">
          <div className="detail-row">
            <span className="label">Communication Address:</span>
            <div className="value address-box">
              {communicationAddress || "--"}
            </div>
          </div>

          <div className="detail-row">
            <span className="label">Permanent Address:</span>
            <div className="value address-box">{permanentFullAddress}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePopUp;
